<template>
  <section class="round-countdown" role="status" aria-live="assertive">
    <p>{{ t('round_transition.get_ready') }}</p>
    <strong>{{ count }}</strong>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
defineProps({ count: { type: Number, required: true } })
const { t } = useI18n()
</script>

<style scoped>
.round-countdown{position:fixed;inset:0;z-index:45;display:grid;place-content:center;justify-items:center;background:rgba(5,9,19,.96);color:#fff;text-align:center;font-family:'Noto Sans',sans-serif}.round-countdown p{margin:0 0 2vh;font-size:clamp(1.35rem,4vh,3rem);font-weight:500}.round-countdown strong{font-size:clamp(6rem,24vh,15rem);line-height:1;color:#ffd65a;font-weight:700}
</style>
